import React from 'react';
import ChemComponent from './ChemComponent';
import Form from 'react-bootstrap/Form';

class ADARadioButton extends ChemComponent {
	
	getPropsExcept(excludedPropNames) {
		return this.getProps(Object.keys(this.props).filter(x => !excludedPropNames.includes(x)));
	}
	
	getProps(requestedPropNames) {
		var keys = Object.keys(this.props);
		var requestedPropValues = {};
		for (var i = 0; i < keys.length; i++) {
			if (requestedPropNames.includes(keys[i])) {
				requestedPropValues[keys[i]] = this.props[keys[i]];
			}
		}
		return requestedPropValues;
	}

	render() {
		return (
			<Form.Check type='radio' {...this.getPropsExcept(inputPropNames)}>
				<Form.Check.Input style={{ borderColor: 'black' }} type='radio' {...this.getProps(inputPropNames)} />
				{!this.isEmpty(this.props.label) && <Form.Check.Label>{this.props.label}</Form.Check.Label>}
			</Form.Check>
		);
	}
}

// these props go to the Form.Check.Input component
// all others go to the Form.Check component
const inputPropNames = ['checked','onChange','onKeyDown'];

export default ADARadioButton;
